export enum PurchaseRequisitionQueryFieldGroup {
  commodity = 'commodity',
  contract = 'contract',
  supplier = 'supplier',
  performance = 'performance',
  product = 'product',
  service = 'service',
  order = 'order',
  location = 'location',
  purchaseRequisition = 'purchaseRequisition',
  commodityGroup = 'commodityGroup',
  sourceSystem = 'sourceSystem',
}
